import { useEffect, useState } from "react";
import api from "./api";

let cache = null;
let inflight = null;

/** Loads clients, contracts, accounts and accounting settings once per session. */
export function useAccounting() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || Promise.all([
      api.get("/accounting/clients"), api.get("/accounting/contracts"),
      api.get("/accounting/accounts"), api.get("/accounting/settings"),
    ]).then(([c, k, a, s]) => {
      cache = { clients: c.data, contracts: k.data, accounts: a.data, settings: s.data };
      return cache;
    }).catch(() => ({ clients: [], contracts: [], accounts: [], settings: { required: false } }));
    inflight.then(setData);
  }, []);
  return data || { clients: [], contracts: [], accounts: [], settings: { required: false }, loading: true };
}

export function invalidateAccounting() { cache = null; inflight = null; }

const compact = (v) => (v || "").replace(/[-\s]/g, "").toUpperCase();

/** Client-side preview of the stored code (backend is the source of truth). */
export function previewCode({ header = {}, line = {}, account, equipmentCode = "", deptoCode = "" }) {
  if (!account) return "";
  const tipos = account.tipo.split("/");
  const tipo = tipos.length === 1 ? tipos[0] : (line.tipo || "?");
  const g = tipo === "G";
  const parts = [
    g ? "00" : (header.client_code || "00"),
    g ? "0000" : (compact(header.contract_code) || "0000"),
    g ? "000" : (header.frente_code || "000"),
    tipo,
    line.depto || deptoCode || account.default_depto || "0000",
    account.subcuenta,
  ];
  if (equipmentCode) parts.push(compact(equipmentCode));
  return parts.join("-");
}

export const TIPO_LABEL = { D: "Directo", I: "Indirecto", G: "G&A", C: "CAPEX", A: "Inventario", V: "Ingreso" };
export const TIPO_CLASS = {
  D: "bg-emerald-600 text-white", I: "bg-amber-500 text-white", G: "bg-slate-600 text-white",
  C: "bg-indigo-600 text-white", A: "bg-sky-600 text-white", V: "bg-rose-600 text-white",
};
